// extracted by mini-css-extract-plugin
export default {"bar":"_3+cAsVW-A68f65iKmkWx6Q=="};